_ = require("lodash")
moment = require('moment')
mapIcon = require('../../../../images/map_icon.png')

class RoundInfoCtrl
  constructor: (@$scope, @$filter, @$window, @flash, @RoundInfoService, @ScoreDataHolderService, @AccordionStateHolderService, @GoogleMapLoaderService) ->
    @GoogleMapLoaderService.load().then =>
      @mapOptions =
        center: new google.maps.LatLng(0, 0)
        zoom: 15
        mapTypeId: google.maps.MapTypeId.ROADMAP

    @_oldCourse = null
    @extra9Options = []
    @hideExtra = true

    #Make sure the accordion is opened to resize the map
    @$scope.$watch (=> @AccordionStateHolderService.steps[1].isOpen), (isOpen) =>
      if isOpen and @myMap
        google.maps.event.trigger @myMap, 'resize'
        @_setMarker @club.loc if @club

    @$scope.$watch (=> @ScoreDataHolderService.club), (club) =>
      return unless club
      @_reset()
      @club = club
      @club.showRakutenId = @club.rakuten_id
      @_setMarker @club.loc if @myMap
      @club.showRakutenId = @club.rakuten_id and @ScoreDataHolderService.fromJapan
      @_setRakutenLink @club.rakuten_id
      @courses = club.courses
      @roundInfo.extra9
      course_selected = club.courses[0] if @club.courses.length is 1
      if club.selected
        course_selected = _.find club.courses, (t) =>
          t.ext_id is club.selected.course_ext_id
        if club.selected.course_extra
          @roundInfo.extra9 = club.selected.course_extra.course_ext_id
          @roundInfo.tee_extra = club.selected.course_extra.tee_extra
      @_generateExtra9Options(@courses)
      @selectCourse(course_selected) if course_selected

    @roundInfoWatch = @$scope.$watch (=> @ScoreDataHolderService.roundInfo), (roundInfo) =>
      if roundInfo
        @roundInfo = _.cloneDeep(roundInfo) #clone to avoid reference to ScoreDataHolderService when changing data
        @selectCourse(roundInfo.course) if roundInfo.course
        @roundInfo.extra_9 = true if roundInfo.round_type == 1.5
        if @roundInfo.course_extra && @roundInfo.holes_extra
          afterFix = if @roundInfo.holes_extra[0].hole_number > 9 then 'IN' else 'OUT'
          @roundInfo.extra9 = "#{@roundInfo.course_extra.ext_id}_#{afterFix}"

      @roundInfoWatch() #Unbinding watch because, we just need it when init

    @_mapWatch = @$scope.$watch (=> @myMap), (map) =>
      return unless map
      #This code is used for edit mode when we have club but map is not initialized
      @_setMarker @club.loc if @club
      #Unbinding watch because, we just need it when init
      @_mapWatch()

  showFlashMessage: ->
    @flash.error @$filter('translate')('_SCORE_REGISTRATION.ROUND_INFO.ERROR_FLASH_MESSAGE')
    return

  submit: ->
    roundInfo = _.merge @roundInfo,
      holes: @roundInfo.tee.holes
    @_resetForm()
    @_getExtra()

    @ScoreDataHolderService.roundInfo = roundInfo
    @AccordionStateHolderService.goToStep(2)

  selectCourse: (course, isChange = false) ->
    if @_oldCourse
      if @$window.confirm @$filter('translate')('_SCORE_REGISTRATION.ROUND_INFO.CONFIRM_CLEAR_DATA')
        @_clearDataWhenCourseChanged()
      else
        @roundInfo.course = @_oldCourse
        if @roundInfo.course?.holes == 18
          @hideExtra = false
        return
    @_oldCourse = course
    @roundInfo.course = course
    if @roundInfo.course?.holes == 18
      @hideExtra = false

    return unless course
    @_setStartHoles(course.holes)
    @_setTees(isChange) #if not @AccordionStateHolderService.editMode

  _getExtra: ->
    unless @roundInfo.extra9
      @roundInfo.extra_9 = false
      @roundInfo.course_extra = undefined
      @roundInfo.tee_extra = undefined
      return

    extraOption = @roundInfo.extra9.split('_')
    @roundInfo.extra_9 = true
    @roundInfo.course_extra = _.find @courses, (t) =>
      t.ext_id is extraOption[0]
    if @roundInfo.tee_extra
      @roundInfo.tee_extra = _.find @tees, (t) =>
        t.ext_id is @roundInfo.tee_extra.ext_id
    else if @tees.length is 1
      @roundInfo.tee_extra = @tees[0]

    holes_extra = _.map @roundInfo.tee_extra.holes, (hole) =>
      if extraOption[1] == 'IN'
        hole if hole.hole_number >= 10
      else
        hole if hole.hole_number < 10

    holes_extra = _.compact(holes_extra)
    @roundInfo.tee_extra.holes = holes_extra
    @roundInfo.holes_extra = holes_extra

  _generateExtra9Options: (courses) ->
    _.map courses, (course) =>
      if course.holes == 18
        @extra9Options.push(["#{course.ext_id}_IN", "#{course.name} IN"])
        @extra9Options.push(["#{course.ext_id}_OUT", "#{course.name} OUT"])

  _getDefaultRoundInfo: ->
    play_date: moment()
    weather: 'sunny'
    course: undefined
    tee: undefined
    started_hole: 1

  _reset: ->
    @_resetForm()
    @_oldCourse = null
    @club = undefined
    @startHoles = []
    @tees = []
    @roundInfo = @_getDefaultRoundInfo()
    @hideExtra = true
    @extra9Options = []

  _resetForm: ->
    @roundInfoForm?.clearForm()

  _clearDataWhenCourseChanged: ->
    @roundInfo.started_hole = undefined
    @roundInfo.tee = undefined
    @roundInfo.tee_extra = undefined
    @roundInfo.extra9 = undefined
    @hideExtra = true
    @_resetForm()
    @AccordionStateHolderService.steps[2].isOpen = false
    @AccordionStateHolderService.steps[3].isOpen = false
    @ScoreDataHolderService.players = null

  _setMarker: (loc) ->
    pos = new google.maps.LatLng loc...
    @myMap.panTo pos
    @markers = []
    @markers.push new google.maps.Marker
      map: @myMap
      position: pos
      icon: mapIcon

  _setRakutenLink: (rakutenId) ->
    return unless rakutenId
    @RoundInfoService.getRakutenLink(rakutenId).then (resp) =>
      @rakutenLink = resp.data.Item.reserveCalUrl

  _setStartHoles: (holeCnt) ->
    @startHoles = [
      value: 1
      label: @$filter('translate')('_SCORE_REGISTRATION.ROUND_INFO.HOLE_1')
    ]
    if holeCnt is 18
      @startHoles.push
        value: 10
        label: @$filter('translate')('_SCORE_REGISTRATION.ROUND_INFO.HOLE_10')


  _refreshTeeDropdown: (data) ->
    @tees = data.tees
    if @roundInfo.tee
      #refresh the dropdown to choose the correct tee because, ng-options will create
      #hash-id so that it can't populate with raw data
      @roundInfo.tee = _.find @tees, (t) =>
        t.ext_id is @roundInfo.tee.ext_id
    else if @tees.length is 1
      #If there is one tee in list -> automatically choose
      @roundInfo.tee = @tees[0]

    if @roundInfo.tee_extra
      @roundInfo.tee_extra = _.find @tees, (t) =>
        t.ext_id is @roundInfo.tee_extra.ext_id
    else if @tees.length is 1
      #If there is one tee in list -> automatically choose
      @roundInfo.tee_extra = @tees[0]

  _setTees: (isChange = false) ->
    @isLoadingTees = true
    @RoundInfoService
      .getTees(@roundInfo.course.ext_id, @club.ext_type)
      .then (resp) =>
        if @club.isHistory && !isChange
          @roundInfo.tee = _.find resp.data.tees, (t) =>
            t.ext_id is @club.selected.tee_ext_id
        @_refreshTeeDropdown(resp.data)
      .finally => @isLoadingTees = false

RoundInfoCtrl.$inject = [
  '$scope'
  '$filter'
  '$window'
  'flash'
  'RoundInfoService'
  'ScoreDataHolderService'
  'AccordionStateHolderService'
  'GoogleMapLoaderService'
]

module.exports = RoundInfoCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/round-info/round-info-controller.coffee